/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */

import BaseAdditionalFormElement
	from "@/core/modules/coach/Resources/Forms/model/FormElements/Additional/BaseAdditionalFormElement";
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import RangeItem from "@/core/modules/coach/Resources/Forms/model/FormElements/Additional/RangeItem";
import {Type} from "class-transformer";
import {ResultTypeEnum} from "@/core/modules/coach/Resources/Forms/model/FormElements/Additional/ResultTypeEnum.js";


export default class FormElementScoreResult extends BaseAdditionalFormElement {

	@Type(() => RangeItem)
	scoreResultRangeItems: RangeItem[] = []

	scoreResultAnswer: number = null
	bucketResultAnswer: number[] = []
	maxValue: number = 10
	isResultPercentage: boolean = false
	resultAsBuckets: boolean = false

	constructor(title) {
		super(FormElementType.SCORE_RESULT, title, false);
		this.addRange()
	}

	clearOptions(){
		this.scoreResultRangeItems = []
		return this
	}


	setResultAsPercentage(isPercentage){
		this.isResultPercentage = isPercentage
		return this
	}

	setResultAsBuckets(isBuckets){
		this.resultAsBuckets = isBuckets
		return this
	}

	resetElement() {
		super.resetElement();
		this.showDescription = true
		this.showRequiredSwitch = false
		this.isRequired = false
		this.placeholder = "Title"
	}

	addRange(label){
		let min = 0
		let lastRange
		let len = this.scoreResultRangeItems.length
		if(len){
			lastRange = this.scoreResultRangeItems[len - 1]
		}

		if(lastRange){
			min = lastRange.max + 1
		}

		let step = 10//Math.max(1, this.maxValue / 10)
		let max = min + step//Math.min(min + step, this.maxValue)

		let newRange = new RangeItem(min, max, label)

		this.scoreResultRangeItems.push(newRange)
		return this
	}

	getRangeByScore(score = this.scoreResultAnswer){
		for(let range of this.scoreResultRangeItems){
			if(range.min <= score && score <= range.max){
				return range
			}
		}
	}
	getScoreTitleByScore(score = this.scoreResultAnswer){
		let range = this.getRangeByScore(score)
		return range ? range.label : ""
	}

	getScoreValue(){
		let resultType = this.isResultPercentage ? ResultTypeEnum.PERCENT : ResultTypeEnum.RAW
		switch (resultType) {
			default:
			case ResultTypeEnum.RAW:
				return this.scoreResultAnswer
			case ResultTypeEnum.PERCENT:
				return Math.round(this.scoreResultAnswer / this.maxValue * 1000) / 10 + "%"
		}
	}

	getBucketTitle(bucketIndex){
		let range = this.scoreResultRangeItems[bucketIndex]
		return range ? range.label : ""
	}

	getBucketValueFormatted(bucketIndex){
		let value = this.getBucketValue(bucketIndex)
		return this.isResultPercentage ? `${value}%` : value
	}

	getBucketValue(bucketIndex){
		let resultType = this.isResultPercentage ? ResultTypeEnum.PERCENT : ResultTypeEnum.RAW
		switch (resultType) {
			default:
			case ResultTypeEnum.RAW:
				return this.bucketResultAnswer[bucketIndex]
			case ResultTypeEnum.PERCENT:
				return Math.round(this.bucketResultAnswer[bucketIndex] / this.maxValue * 1000) / 10
		}

	}





}
